module.exports = __webpack_public_path__ + "img/vision_03.afba2df7.webp";